<template>
  <div class="relative">
    <div class="absolute right-2 top-3">{{this.store}}</div>
    <vue-country-code
        @onSelect="onSelect"
        defaultCountry="IR"
        :enableSearchField=true
        searchPlaceholderText=""
        >
    </vue-country-code>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCountryCode from "vue-country-code-select";

Vue.use(VueCountryCode);
export default {
  data(){
    return{
      store: '',
    }
  },
  methods: {
    onSelect({ dialCode}) {
      this.store = dialCode
      let countryCode = this.store
      // console.log(countryCode);
      this.$emit('codeUpdate' , countryCode)
    },
  }
}
</script>

<style>
.vue-country-select{
  border: 1px solid #d1d5db !important;
  border-radius: 9px !important;
}
.dropdown:hover{
  background-color: unset !important;
}
.dropdown.open{
  background-color: unset !important;
}
.dropdown{
  align-items: flex-end !important;
}
.vue-country-select:focus-within{
  box-shadow:none !important;
  border-color:#d1d5db !important;
}
.vue-country-select{
  height: 46px !important;
  width:70px !important;
}
</style>